import Backbone from 'backbone';
import $ from 'jquery';
import ko from 'knockout';
import _ from 'underscore';
import {
  GOAL_OPERATOR_TYPES_STRING_VALUES,
  getDestUrlData,
  getEventData,
  formatDecimal,
  NOT_AVAILABLE_DEFAULT_STR,
  APPLY_USERINPUT_TYPES,
  CONTEXTUAL_ENTITY_TYPE,
  ISSUE_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import {
  withContextualAttributeTemplate,
  showContextualAttribute,
  hideContextualAttribute,
} from '@bingads-webui-campaign/recommendation-contextual-attribute';

import ViewModel from '../viewmodel/fix-coversion-goal-setting-model';
import destUrlTemplate from '../template/fix-conversion-goal-setting-dest-url.pug';
import eventTemplate from '../template/fix-conversion-goal-setting-event.pug';
import revenueValueTemplate from '../template/fix-conversion-goal-setting-revenue-value.pug';

export default class FixConversionGoalSettingView extends Backbone.View {
  initialize({
    deps,
    data = {},
    i18n,
    router,
    gridView,
    readOnly,
    isMCC,
    scope,
    gridService,
    s$i18n,
    newI18n,
    viewUET,
  }) {
    this.deps = deps;
    this.data = _.first(data.Opportunities);
    this.accountName = data.Target.AccountName;
    this.i18n = i18n;
    this.router = router;
    this.ko_model = new ViewModel({ data, i18n, deps });
    this.grid = { gridView };
    this.readOnly = readOnly;
    this.isMCC = isMCC;
    this.scope = scope;
    this.gridService = gridService;
    this.s$i18n = s$i18n;
    this.newI18n = newI18n;
    this.viewUET = viewUET;
  }

  get events() {
    return {
      'click .apply': 'apply',
      'click .btn-cancel': 'closeInlineView',
      'mouseover .recommendation-inline-fix-conversion-goal-setting-view .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .recommendation-inline-fix-conversion-goal-setting-view .contextual-tooltip': 'hideContextualAttributePopup',
    };
  }

  contextualAttributeWrapper = options => withContextualAttributeTemplate({
    opportunityId: options.opportunityId,
    entityName: options.entityName,
    entityId: options.entityId,
    entityType: CONTEXTUAL_ENTITY_TYPE.CURRENT_SETTING,
    status: 'false',
    isExpandingView: true,
    ariaLabel: this.i18n.getString('Click to scope to current setting'),
    style: { color: '#A80000' },
  })

  hideContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    hideContextualAttribute({ e, self: this });
  }

  showContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    this.timerForPopupContextualAttribute = setTimeout(() => {
      showContextualAttribute({
        deps: this.deps,
        i18n: this.i18n,
        e,
        type: this.data.OpportunityType,
        isExpanding: true,
        self: this,
        scope: this.scope,
        recommendationService: this.gridService.recommendationService,
        s$i18n: this.s$i18n,
        newI18n: this.newI18n,
      });
    }, 500);
  }

  apply() {
    const { data } = this;
    const model = this.ko_model;
    if (model.isValid()) {
      const basicInput = {
        '@odata.type': APPLY_USERINPUT_TYPES[data.OpportunityType],
        OpportunityId: data.OpportunityId,
      };

      let editedSetting;
      if (data.GoalTypeId === 0 && data.DestUrl) { // Goal type is Destination URL
        editedSetting = {
          NewGoal: {
            '@odata.type': '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.DestinationGoal',
            UrlString: model.urlString(),
            Operator: model.operator(),
          },
        };
      } else if (data.GoalTypeId === 3 && data.Event) { // Goal type is Event
        editedSetting = {
          NewGoal: {
            '@odata.type': '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.EventGoal',
            Category: model.category() ? model.category() : undefined,
            CategoryOperator: model.category() ? model.categoryOperator() : undefined,
            Action: model.action() ? model.action() : undefined,
            ActionOperator: model.action() ? model.actionOperator() : undefined,
            Label: model.label() ? model.label() : undefined,
            LabelOperator: model.label() ? model.labelOperator() : undefined,
            Value: model.value() && !_.isNaN(model.value()) ?
              Number(model.value()) : undefined,
            ValueOperator: model.value() ? model.valueOperator() : undefined,
          },
        };
      } else if (data.IssueType === 4 && data.RevenueValue) { // Issue type is RevenueValue
        editedSetting = {
          NewGoal: {
            '@odata.type': '#Microsoft.Advertiser.AdInsight.Opportunity.Core.Adoption.Interface.Entity.RevenueValueModification',
            NewRevenueValue: model.inputRevenueValue() && !_.isNaN(model.inputRevenueValue()) ?
              Number(model.inputRevenueValue()) : undefined,
          },
        };
      }

      this.trigger(
        'apply',
        {
          opportunities: [this.data],
          userInputs: [_.extend(basicInput, editedSetting)],
        }
      );
    }
  }

  closeInlineView(e) {
    e.stopImmediatePropagation();
    this.remove();
    this.trigger('cancel');
  }

  parseOperator(operator) {
    switch (operator) {
      case 'Equals to':
        return 'EqualsTo';
      case 'Less than':
        return 'LessThan';
      case 'Greater than':
        return 'GreaterThan';
      case 'Begins with':
        return 'BeginsWith';
      case 'Regular expression':
        return 'RegularExpression';
      default:
        return operator;
    }
  }

  hasChanged() {
    const { data } = this;
    const model = this.ko_model;
    switch (data.IssueType) {
      case 1: // Issue type is Destination URL
        return model.operator() !== this.parseOperator(model.suggestedDestinationURLOperatorName) ||
          model.urlString() !== model.suggestedDestinationUrl;
      case 2: // Issue type is Event
        return model.category() !== model.suggestedCategoryName ||
          model.categoryOperator() !== this.parseOperator(model.suggestedCategoryOperatorName) ||
          model.action() !== model.suggestedActionName ||
          model.actionOperator() !== this.parseOperator(model.suggesteActionOperatorName) ||
          model.label() !== model.suggestedLabelName ||
          model.labelOperator() !== this.parseOperator(model.suggestedLabelOperatorName) ||
          Number(model.value()) !== model.suggestedValueName ||
          model.valueOperator() !== this.parseOperator(model.suggesteValueOperatorName);
      case 4: // Issue type is Revenue Value
        if (model.inputRevenueValue && Number(model.inputRevenueValue()) !== 1) {
          return true;
        }
        return false;
      default:
        return false;
    }
  }

  render() {
    const {
      data, i18n, newI18n,
    } = this;
    const goalOperatorTypes = GOAL_OPERATOR_TYPES_STRING_VALUES;
    const goalName = withContextualAttributeTemplate({
      opportunityId: data.OpportunityId,
      entityName: data.GoalName,
      entityId: data.GoalId,
      entityType: CONTEXTUAL_ENTITY_TYPE.GOAL,
      status: 'false',
      isExpandingView: true,
      ariaLabel: this.i18n.getString('Click to scope to goal {{goalName}}', { goalName: data.GoalName }),
      accountName: this.accountName,
    });
    const issueTypeId = data.IssueType;
    const baseParams = _.extend(this.ko_model, {
      i18n: this.i18n,
      readOnly: this.readOnly,
      title: newI18n.getString(_TL_('Change conversion goal setting for {{goalName}}, Issue Scope: {{issueType}}'), {
        goalName,
        issueType: ISSUE_TYPES[issueTypeId],
      }),
      estimation: _.isNumber(data.EstimatedIncreaseInConversionsInt) ?
        formatDecimal(data.EstimatedIncreaseInConversionsInt, i18n) : NOT_AVAILABLE_DEFAULT_STR,
    });

    if (data.GoalTypeId === 0 && data.DestUrl) { // Goal type is Destination URL
      const destUrlCurrentSetting = data.DestUrl.CurrentSetting;
      const destUrlSuggestedSetting = data.DestUrl.SuggestedSetting;

      const destUrlData = getDestUrlData(
        destUrlCurrentSetting,
        destUrlSuggestedSetting,
        goalOperatorTypes,
        i18n
      );

      if (destUrlData.currentDestinationUrl !== null &&
        destUrlData.suggestedDestinationURLOperatorName
        !== destUrlData.currentDestinationURLOperatorName) {
        destUrlData.currentDestinationURLOperatorName = this.contextualAttributeWrapper({
          opportunityId: data.OpportunityId,
          entityName: destUrlData.currentDestinationURLOperatorName,
          entityId: `${data.OpportunityId}_currentDestinationURLOperatorName`,
        });
      }

      if (destUrlData.currentDestinationUrl !== null &&
        destUrlData.suggestedDestinationUrl !== destUrlData.currentDestinationUrl) {
        destUrlData.currentDestinationUrl = this.contextualAttributeWrapper({
          opportunityId: data.OpportunityId,
          entityName: destUrlData.currentDestinationUrl,
          entityId: `${data.OpportunityId}_currentDestinationUrl`,
        });
      }

      const params = _.extend(baseParams, destUrlData);
      this.$el.html($(destUrlTemplate(params)));
    } else if (data.GoalTypeId === 3 && data.Event) { // Goal type is Event
      const eventCurrentSetting = data.Event.CurrentSetting;
      const eventSuggestedSetting = data.Event.SuggestedSetting;
      const eventData = getEventData(
        eventCurrentSetting,
        eventSuggestedSetting,
        goalOperatorTypes,
        i18n
      );

      if (eventData.currentCategoryName !== null &&
        eventData.suggestedCategoryName !== eventData.currentCategoryName) {
        eventData.currentCategoryName = this.contextualAttributeWrapper({
          opportunityId: data.OpportunityId,
          entityName: eventData.currentCategoryName,
          entityId: `${data.OpportunityId}_currentCategoryName`,
        });
      }

      if (eventData.currentCategoryName !== null &&
        eventData.suggestedCategoryOperatorName !== eventData.currentCategoryOperatorName) {
        eventData.currentCategoryOperatorName = this.contextualAttributeWrapper({
          opportunityId: data.OpportunityId,
          entityName: eventData.currentCategoryOperatorName,
          entityId: `${data.OpportunityId}_currentCategoryOperatorName`,
        });
      }

      if (eventData.currentActionName !== null &&
        eventData.suggestedActionName !== eventData.currentActionName) {
        eventData.currentActionName = this.contextualAttributeWrapper({
          opportunityId: data.OpportunityId,
          entityName: eventData.currentActionName,
          entityId: `${data.OpportunityId}_currentActionName`,
        });
      }

      if (eventData.currentActionName !== null &&
        eventData.suggesteActionOperatorName !== eventData.currentActionOperatorName) {
        eventData.currentActionOperatorName = this.contextualAttributeWrapper({
          opportunityId: data.OpportunityId,
          entityName: eventData.currentActionOperatorName,
          entityId: `${data.OpportunityId}_currentActionOperatorName`,
        });
      }

      if (eventData.currentLabelName !== null &&
        eventData.suggestedLabelName !== eventData.currentLabelName) {
        eventData.currentLabelName = this.contextualAttributeWrapper({
          opportunityId: data.OpportunityId,
          entityName: eventData.currentLabelName,
          entityId: `${data.OpportunityId}_currentLabelName`,
        });
      }

      if (eventData.currentLabelName !== null &&
        eventData.suggestedLabelOperatorName !== eventData.currentLabelOperatorName) {
        eventData.currentLabelOperatorName = this.contextualAttributeWrapper({
          opportunityId: data.OpportunityId,
          entityName: eventData.currentLabelOperatorName,
          entityId: `${data.OpportunityId}_currentLabelOperatorName`,
        });
      }

      if (eventData.currentValueName !== null &&
        eventData.suggestedValueName !== eventData.currentValueName) {
        eventData.currentValueName = this.contextualAttributeWrapper({
          opportunityId: data.OpportunityId,
          entityName: eventData.currentValueName,
          entityId: `${data.OpportunityId}_currentValueName`,
        });
      }

      if (eventData.currentValueName !== null &&
        eventData.suggesteValueOperatorName !== eventData.currentValueOperatorName) {
        eventData.currentValueOperatorName = this.contextualAttributeWrapper({
          opportunityId: data.OpportunityId,
          entityName: eventData.currentValueOperatorName,
          entityId: `${data.OpportunityId}_currentValueOperatorName`,
        });
      }

      const params = _.extend(baseParams, eventData);
      this.$el.html($(eventTemplate(params)));
    } else if (issueTypeId === 4 && data.RevenueValue) {
      const revenueValueData = {
        goalValueSourceId: data.RevenueValue.GoalValueSourceId,
        subtitleCurrent: newI18n.getString(_TL_('Current')),
        sameGoalText: newI18n.getString(_TL_('Each conversion action has the same value (Fix value: {{conversionValue}})'), { conversionValue: data.RevenueValue.ConversionValue }),
        variousGoalText: newI18n.getString(_TL_('Conversion action value may vary (but system can’t track the value)')),
        notAssignGoaText: newI18n.getString(_TL_('Don’t assign a value')),
        subtitleFixIssue: newI18n.getString(_TL_('Follow the instructions to fix the issue')),
        subtitleRevenue: newI18n.getString(_TL_('Revenue value:')),
        pitchingRevenue: [
          newI18n.getString(_TL_('Conversion action value may vary(for example, by purchase price)')),
          newI18n.getString(_TL_('If no value is assigned what should the default value be?')),
        ],
        suggestedVariousGoalText: [
          newI18n.getString(_TL_('You’ll need to')),
          newI18n.getString(_TL_('tracking code to report variable Revenue value')),
        ],
        UETLinkText: newI18n.getString(_TL_('customize your UET tag')),
        viewUET: () => this.viewUET(),
      };
      const params = _.extend(baseParams, revenueValueData);
      this.$el.html($(revenueValueTemplate(params)));
    }

    ko.applyBindings(this.ko_model, this.$el[0]);
    this.delegateEvents();

    return this;
  }
}
